import React from 'react'

function TenderTextRKF() {
  return (
    <embed src="\pdfs\EA2.5_rk-f10_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextRKF